import Vue from 'vue';
import Vuex from 'vuex';
// assets
import actions from './actions';
import mutations from './mutations';
// modules
import admin from './modules/admin';
import port from './modules/port';
import device from './modules/device';
import project from './modules/project';
import menu from './modules/menu';
import meta from './modules/meta';
import collection from './modules/collection';
import group from './modules/group';
import banner from './modules/banner';
import cmd from './modules/cmd';
import cluster from './modules/cluster';

Vue.use(Vuex);

const state = {
  caluploads: [], // 已上传校准文件
};

export default new Vuex.Store({
  state,
  mutations,
  actions,
  modules: {
    admin,
    port,
    device,
    project,
    menu,
    meta,
    collection,
    group,
    banner,
    cmd,
    cluster,
  },
});

